import { BaseError } from "../BaseError";

export const CLEAR_TYPE = {
  FULLCOMBO_CLEAR: 7,
  EX_HARD_CLEAR: 6,
  HARD_CLEAR: 5,
  CLEAR: 4,
  EASY_CLEAR: 3,
  ASSIST_CLEAR: 2,
  FAILED: 1,
  NO_PLAY: 0,
} as const;

export type ClearType = (typeof CLEAR_TYPE)[keyof typeof CLEAR_TYPE];

export const CLEAR_TYPE_STRING = {
  7: "FULLCOMBO CLEAR",
  6: "EX HARD CLEAR",
  5: "HARD CLEAR",
  4: "CLEAR",
  3: "EASY CLEAR",
  2: "ASSIST CLEAR",
  1: "FAILED",
  0: "NO PLAY",
} as const;

export const CLEAR_TYPE_COLOR = {
  7: "#FF8C00",
  6: "#FFD900",
  5: "#FF6347",
  4: "#AFEEEE",
  3: "#98FB98",
  2: "#9595FF",
  1: "#C0C0C0",
  0: "#FFFFFF",
} as const;

export const isClearType = (n: unknown): n is ClearType => {
  return typeof n === "number" && Object.values<typeof n>(CLEAR_TYPE).includes(n);
};

export const parseClearType = (str: string): ClearType => {
  const result = Object.values(CLEAR_TYPE).find((key) => CLEAR_TYPE_STRING[key] === str);
  if (result === undefined) {
    throw new ParseClearTypeError("ClearTypeに変換できません");
  }
  return result;
};

export class ParseClearTypeError extends BaseError {}
